export class IPUtil {
  public static get IP_V4_EXP(): string {
    return "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$";
  }

  public static ipv4ToLong(ipAddress: string): number {
    let result: number = 0.0;
    let temp: string[] = ipAddress.split(".");

    temp.forEach((t) => {
      result *= 256.0;
      result += Number(t);
    });

    return result;
  }

  public static isIpv4String(ipAddress: string): boolean {
    return new RegExp(this.IP_V4_EXP).test(ipAddress);
  }
}
